import { ChakraBox } from '@equip.health/ui';

interface ChannelDividerProps {
  index: number;
  totalCount: number;
}

const ChannelDivider = ({ index, totalCount }: ChannelDividerProps) => {
  if (index === totalCount - 1) return <></>;
  return (
    <ChakraBox borderColor="neutral.line" borderWidth="1px" height="1px" />
  );
};

export default ChannelDivider;
